import { Stack, SvgIcon, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

import { useTheme } from '@sumologic/yama-ds-components';

import { eventPageIconsMap, eventPageLabelsMap, EventPages } from './constants';

export interface EventPageHeaderProps {
  currentPage: EventPages;
  renderHeaderActions?: () => ReactNode;
}

export const EventPageHeader = ({
  currentPage,
  renderHeaderActions,
}: EventPageHeaderProps) => {
  const { palette } = useTheme();

  const Icon = eventPageIconsMap[currentPage];

  return (
    <Stack
      data-sumo-test='event-page-header'
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      mb={2}
    >
      <Stack direction='row' alignItems='center' spacing={1}>
        <SvgIcon
          component={Icon}
          inheritViewBox
          sx={{
            color: palette.tokens.YamaTypographyColorIcon,
            height: 24,
            mr: 1,
            width: 24,
          }}
        />
        <Typography
          variant='h1'
          data-sumo-test='event-page-header-title'
          mb={0}
        >
          {eventPageLabelsMap[currentPage]}
        </Typography>
      </Stack>
      {renderHeaderActions && renderHeaderActions()}
    </Stack>
  );
};

export default EventPageHeader;
